class LocationService {
    /**
     * Returns the current location coordinates
     * @returns {Promise<R>}
     */
    static getCurrentPosition(): Promise<{
        latitude: number;
        longitude: number;
    }> {
        return new Promise((resolve: Function, reject: Function) => {
            if (!navigator.geolocation) {
                // Reject the promise
                reject("general.currentPosition.error");
            }

            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const {
                        coords: { latitude, longitude }
                    } = pos;

                    // Get current position succeed
                    resolve({
                        latitude,
                        longitude
                    });
                },
                (geoError) => {
                    if (
                        geoError.code ===
                        window.GeolocationPositionError.PERMISSION_DENIED
                    ) {
                        reject("general.geolocation.permissionDenied");
                        return;
                    }
                    // Timeout or Position unavailable
                    reject("general.currentPosition.error");
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 10000
                }
            );
        });
    }
}

export { LocationService };
